/**
 * Typography Control Utilities
 *
 * Main export file for all typography utility functions
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

export { getTypographyValues } from './get-typography-values';
export { hasAnyTypographyValues } from './has-any-typography-values';
export { resetTypographyAttributes } from './reset-typography-attributes';
export { updateTypographyProperty } from './update-typography-property';

// Export style utilities
export { getTypographyCSS } from '../style';
export { generateTypographyCSSRules } from '../style/rules';
